import { createAction } from '@reduxjs/toolkit';

export const sheetActions = {
    loadSheet: createAction('sheet/load'),
    reset: createAction('sheet/reset'),
};
